import { BASE_URL } from './config'

async function fetchWithHandling(url: string, options: RequestInit) {
  const response = await fetch(url, options)
  if (!response.ok) {
    let errorMessage = 'An error occurred'
    try {
      const errorData = await response.json()
      errorMessage = errorData.message || errorMessage
    } catch (e) {
      errorMessage = response.statusText
    }
    throw new Error(errorMessage)
  }
  return response.json()
}

export async function getSessions(
  token: string,
  filters?: { from?: string; to?: string },
) {
  let url = `${BASE_URL}/api/v1/sessions`
  if (filters) {
    const params = new URLSearchParams()
    if (filters.from) params.append('from', filters.from)
    if (filters.to) params.append('to', filters.to)
    const queryString = params.toString()
    if (queryString) url += `?${queryString}`
  }
  return fetchWithHandling(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function getSession(token: string, id: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/sessions/${id}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function getReadings(
  token: string,
  sessionId: string,
  filters?: {
    from?: string
    to?: string
    sensorType?: string
    limit?: number
    offset?: number
  },
) {
  let url = `${BASE_URL}/api/v1/sessions/${sessionId}/readings`
  if (filters) {
    const params = new URLSearchParams()
    if (filters.from) params.append('from', filters.from)
    if (filters.to) params.append('to', filters.to)
    if (filters.sensorType) params.append('sensorType', filters.sensorType)
    if (filters.limit) params.append('limit', filters.limit.toString())
    if (filters.offset) params.append('offset', filters.offset.toString())
    const queryString = params.toString()
    if (queryString) url += `?${queryString}`
  }
  return fetchWithHandling(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function endSession(token: string, id: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/sessions/${id}/end`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
}
